import * as React from 'react';

import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetail/ProductDetailContext';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { ProductEventWither } from '@helpers/googleTagManager';

import { trackShadefinderDisplayResult } from '../tracking';

export const useTrackShadefinderLoaded = (
  variant: CatalogVariantFragmentFragment,
  timeOfStart: number
) => {
  const { getVariant, getTimeFromInit } = useTrackingContext();
  const { product } = useProductDetailContext();

  React.useEffect(() => {
    trackShadefinderDisplayResult({
      variant: getVariant(),
      product: ProductEventWither()
        .withProduct(product)
        .withVariant(variant)
        .build(),
      timing: getTimeFromInit(timeOfStart),
    });
  }, [variant, getTimeFromInit, getVariant, product, timeOfStart]);
};
